import Phaser from "phaser";

import Pqp from "../../3x1010/Pqp";
import PagePlayer from "../PagePlayer";
import MainScene from "./MainScene";
import UiInterface from "./UiInterface";
import ZoomPanel from "./ZoomPanel";
import Tracking from "./Tracking";

export default class ProgressBar extends Phaser.GameObjects.Container {
  constructor(scene, barWidth, phases, perform, callback) {
    super(scene);
    this.barWidth = barWidth;
    this.callback = callback;
    this.phases = phases;
    this.perform = perform;
    this.videoAlreadyPaused = false;
    this.workaround = false;
    this.points = [];
  }

  init() {
    const barBack = this.scene.add.rectangle(0, 0, this.barWidth, 2, ProgressBar.COLOR_BACK);
    barBack.setOrigin(0, 0);
    this.add(barBack);

    const barSeekLower = this.scene.add.rectangle(0, 0, this.barWidth, 2, ProgressBar.COLOR_2);
    barSeekLower.setOrigin(0, 0);
    this.add(barSeekLower);
    this.barSeekLower = barSeekLower;
    this.barSeekLower.visible = false;

    this.bar = this.scene.add.rectangle(0, 0, this.barWidth, 2, ProgressBar.COLOR_FRONT);
    this.bar.setOrigin(0, 0);
    this.add(this.bar);

    const barSeekUpper = this.scene.add.rectangle(0, 0, this.barWidth, 2, ProgressBar.COLOR_2);
    barSeekUpper.setOrigin(0, 0);
    this.add(barSeekUpper);
    this.barSeekUpper = barSeekUpper;
    this.barSeekUpper.visible = false;

    this.createPhases();

    this.barHit = this.scene.add.rectangle(0, -8, this.barWidth, 16, ProgressBar.COLOR_FRONT);
    this.barHit.setOrigin(0, 0);
    this.add(this.barHit);
    this.barHit.alpha = 0.001;
    this.barHit.setInteractive();
    this.barHit.on("pointerup", this.onJumpBar.bind(this));
    this.barHit.on("pointermove", this.overJumpBar.bind(this));
    this.barHit.on("pointerout", this.outJumpBar.bind(this));

    // Pomello
    this.knob = this.scene.add.container(0, 0);
    this.smaller = this.scene.add.circle(0, 0, ProgressBar.CIRCLE_RADIUS, ProgressBar.COLOR_FRONT);

    this.knob.add(this.smaller);
    this.bigger = this.scene.add.circle(0, 0, ProgressBar.CIRCLE_RADIUS_BIGGER, ProgressBar.COLOR_FRONT);

    this.knob.add(this.smaller);
    this.knob.add(this.bigger);
    this.add(this.knob);
    this.bigger.visible = false;

    this.knob.setInteractive({ hitArea: new Phaser.Geom.Rectangle(-ProgressBar.CIRCLE_RADIUS_BIGGER * 2, -ProgressBar.CIRCLE_RADIUS_BIGGER * 1, ProgressBar.CIRCLE_RADIUS_BIGGER * 4, ProgressBar.CIRCLE_RADIUS_BIGGER * 2), hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: true });
    this.scene.input.setDraggable(this.knob);
    this.scene.input.dragDistanceThreshold = 2;

    if (!Pqp.isMobile()) {
      this.knob.on("pointerover", this.onOver.bind(this));
      this.knob.on("pointerout", this.onOut.bind(this));
    }
    this.knob.on("dragstart", this.onDragStart.bind(this));
    this.knob.on("dragend", this.onDragEnd.bind(this));
    this.knob.on("drag", this.onDrag.bind(this));

    this.bar.setScale(0.0001, 1);

    //this.createPerform();
  }

  overJumpBar(e, x) {
    this.barSeekUpper.visible = false;
    this.barSeekLower.visible = false;

    if (x > this.knob.x) {
      this.barSeekLower.visible = true;
    } else {
      this.barSeekUpper.visible = true;
    }
    this.barSeekLower.width = x;
    this.barSeekUpper.width = x;
    this.dispatch(ProgressBar.EVENT_SHOW_TIME_TO_SEEK_TO, x / this.barWidth);
  }

  outJumpBar(e) {
    this.barSeekUpper.visible = false;
    this.barSeekLower.visible = false;
    this.dispatch(ProgressBar.EVENT_HIDE_TIME_TO_SEEK_TO);
  }

  createPhases() {
    const a = this.phases;
    const duration = MainScene.that.vid.getDuration();
    let strokeNumber = 0;
    for (let x = 1; x < a.length; x++) {
      if (!a[x].stroke.fasi[0].colpoNonValido) {
        if (a[x].startStroke) {
          this.tmpStartStroke = a[x];
          strokeNumber++;
        }
        if (!a[x].hiddenBar) {
          const vbar = this.createVbar(a[x].startStroke || a[x].endStroke);
          this.add(vbar);
          const perc = a[x].time / 1000 / duration;
          vbar.x = this.barWidth * perc;
          //vbar.y = -ProgressBar.VBAR_HEIGHT;
          vbar.y = a[x].startStroke || a[x].endStroke ? -ProgressBar.VBAR_HEIGHT_START_STROKE / 2 : -ProgressBar.VBAR_HEIGHT;
        }

        if (a[x].endStroke) {
          const enabled = a[x].stroke.valid;
          const hbar = this.createHbar(this.tmpStartStroke, a[x], enabled);
          //hbar.visible = false;
          const lens = this.createLens(hbar, a[x].stroke);
          hbar.on("pointerover", () => {
            lens.visible = true;
          });
          hbar.on("pointerout", () => {
            lens.visible = false;
          });
          // Ultimo parametro inizio del colpo sulla timeline
          const posTestina = this.barWidth * (this.tmpStartStroke.time / 1000 / duration);

          if (enabled) {
            hbar.on("pointerup", this.onShowZoomPanel.bind(this, a[x].stroke.uid, a[x].stroke, hbar.x + hbar.displayWidth / 2, posTestina, strokeNumber));
          }

          this.createStrokeLabel(strokeNumber, hbar, a[x].stroke, enabled);
        }
      }
    }
  }

  createVbar(lHigher = false) {
    const h = lHigher ? ProgressBar.VBAR_HEIGHT_START_STROKE : ProgressBar.VBAR_HEIGHT;
    const color = lHigher ? ProgressBar.COLOR_LABELS : ProgressBar.COLOR_BACK;
    const vbar = this.scene.add.rectangle(0, 0, UiInterface.BAR_THICKNESS, h, color);
    vbar.setOrigin(0, 0);
    return vbar;
  }

  createHbar(start, end, enabled) {
    const duration = MainScene.that.vid.getDuration();
    const timeDuration = end.time - start.time;
    const widthBar = (timeDuration / 1000 / duration) * this.barWidth;
    //const hbar = this.scene.add.rectangle(0, 0, widthBar, UiInterface.BAR_THICKNESS, ProgressBar.COLOR_LABELS);
    const hbar = this.scene.add.rectangle(0, 0, widthBar, ProgressBar.VBAR_HEIGHT_START_STROKE + ProgressBar.VBAR_HEIGHT_START_STROKE, ProgressBar.COLOR_LABELS);
    if (enabled) {
      hbar.setInteractive({ hitArea: new Phaser.Geom.Rectangle(0, 0, widthBar, ProgressBar.VBAR_HEIGHT_START_STROKE + ProgressBar.VBAR_HEIGHT_START_STROKE), hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: true });
    }
    hbar.alpha = 0.000001;
    hbar.setOrigin(0, 0);
    hbar.x = this.barWidth * (start.time / 1000 / duration);
    //hbar.y = -ProgressBar.VBAR_HEIGHT_START_STROKE / 4;
    hbar.y = -ProgressBar.VBAR_HEIGHT_START_STROKE;
    this.add(hbar);
    return hbar;
  }

  createStrokeLabel(strokeNumber, hbar, stroke, enabled) {
    let color;
    if (enabled) {
      // Calcola il colore in base agli errori
      let errors = 0;
      for (let x = 0; x < stroke.fasi.length; x++) {
        errors += stroke.fasi[x].erroriTotali;
      }
      let index = Math.floor(errors / ProgressBar.ERROR_COLOR_INTERVAL);
      if (index >= ProgressBar.ERROR_COLORS.length) {
        index = ProgressBar.ERROR_COLORS.length - 1;
      }
      color = ProgressBar.ERROR_COLORS[index];
      if (errors === 0) {
        color = ProgressBar.NO_ERROR_COLOR;
      }
      color = this.toHexColor(color);
    } else {
      color = 0xaaaaaa;
    }
    const txt = this.scene.add.text(0, 0, "C" + strokeNumber, { fontFamily: "DIN Next LT Pro", fontSize: "24px", color: color, align: "center", wordWrap: { width: 320 }, lineSpacing: -6 });
    txt.setOrigin(0, 0);
    txt.x = hbar.x + hbar.displayWidth / 2 - txt.width / 2;
    txt.y = hbar.y + 56;
    //txt.setStroke(Tracking.STROKE_COLOR, Tracking.STROKE_INTENSITY);
    this.add(txt);
  }

  createLens(hbar, stroke) {
    const lens = this.scene.add.image(0, 0, "lens");
    lens.setOrigin(0, 0);
    lens.x = hbar.x + hbar.displayWidth / 2 - lens.displayWidth / 2;
    lens.y = hbar.y - lens.displayHeight + 16;
    this.add(lens);
    lens.visible = false;
    //lens.setInteractive({ useHandCursor: true });
    //lens.on("pointerup", this.onShowZoomPanel.bind(this, stroke.uid, stroke, hbar.x + hbar.displayWidth / 2));
    return lens;
  }

  gotoTime(time) {
    //console.log("gotoTime", time);
    // Converte il tempo nella x e chiama onJumpBar
    const perc1 = time / MainScene.that.vid.getDuration();
    //this.onJumpBar(null, perc * this.barWidth);
    const x = perc1 * this.barWidth;

    this.videoAlreadyPaused = true;
    const perc = x / this.barWidth;
    this.dispatch(ProgressBar.EVENT_MOVED_KNOB, { percent: perc, seek: true });
    let lAlready = false;
    if (MainScene.that.videoPaused) {
      lAlready = true;
    }
    this.onOver();
    if (!lAlready) {
      this.workaround = true;
      this.videoAlreadyPaused = false;
    }
    this.smaller.visible = true;
    this.bigger.visible = false;
  }

  onJumpBar(e, x) {
    this.closeZoomPanel();
    if (typeof x !== "number") {
      x = e;
    }
    const perc = x / this.barWidth;
    this.dispatch(ProgressBar.EVENT_MOVED_KNOB, { percent: perc, seek: true });
    let lAlready = false;
    if (MainScene.that.videoPaused) {
      lAlready = true;
    }
    this.onOver();
    if (!lAlready) {
      this.workaround = true;
      this.videoAlreadyPaused = false;
    }
  }

  onJumpAlt(x) {
    const perc = x / this.barWidth;
    this.dispatch(ProgressBar.EVENT_MOVED_KNOB, { percent: perc, seek: true });
    this.videoAlreadyPaused = false;
    if (MainScene.that.videoPaused) {
      this.videoAlreadyPaused = true;
    } else {
      this.dispatch(ProgressBar.EVENT_PAUSE);
    }
  }

  onDragStart(pointer, dragX, dragY) {}

  onDrag(pointer, dragX, dragY) {
    this.closeZoomPanel();
    clearTimeout(this.idto);
    this.idto = setTimeout(this.moveBar.bind(this), 50);
    this.knob.x = dragX;
    if (this.knob.x < 0) {
      this.knob.x = 0;
    }
    if (this.knob.x > this.barWidth) {
      this.knob.x = this.barWidth;
    }

    this.dispatch(ProgressBar.EVENT_MOVED_KNOB, { percent: this.knob.x / this.barWidth, seek: false });
  }

  moveBar() {
    this.dispatch(ProgressBar.EVENT_MOVED_KNOB, { percent: this.knob.x / this.barWidth, seek: true });
  }

  onDragEnd(pointer, gameObject, dragX, dragY) {}

  onOver() {
    if (this.panelInfo) {
      return;
    }
    if (this.workaround) {
      this.workaround = false;
      return;
    }
    this.videoAlreadyPaused = false;
    if (MainScene.that.videoPaused) {
      this.videoAlreadyPaused = true;
    } else {
      this.dispatch(ProgressBar.EVENT_PAUSE);
    }
    this.smaller.visible = false;
    this.bigger.visible = true;
  }

  onOut() {
    if (this.panelInfo) {
      return;
    }
    if (!this.videoAlreadyPaused) {
      this.dispatch(ProgressBar.EVENT_RESUME);
    }
    this.smaller.visible = true;
    this.bigger.visible = false;
  }

  setBar(percent) {
    this.bar.setScale(percent, 1);
    this.knob.x = this.bar.displayWidth;
    if (this.zoomPanel) {
      this.zoomPanel.setBar(percent);
    }
  }

  dispatch(type, data) {
    if (this.callback) {
      const e = { type };
      if (!Pqp.isNullOrEmpty(data)) {
        e.data = data;
      }
      this.callback.call(null, e);
    }
  }

  createPerform() {
    const a = this.perform;
    const duration = MainScene.that.vid.getDuration();
    for (let x = 0; x < a.length; x++) {
      const pointContainer = this.scene.add.container(0, 0);
      this.add(pointContainer);
      const point = this.scene.add.circle(0, 0, ProgressBar.PERFORM_RADIUS, ProgressBar["COLOR_" + a[x].type]);
      pointContainer.add(point);
      const perc = a[x].time / 1000 / duration;
      pointContainer.x = this.barWidth * perc;
      //point.y = x % 2 === 0 ? ProgressBar.PERFORM_DISTANCE_Y : -ProgressBar.PERFORM_DISTANCE_Y;

      pointContainer.y = ProgressBar.PERFORM_DISTANCE_Y;
      a[x].lUp = false;
      if (a[x].type === ProgressBar.PERFORM_OK) {
        pointContainer.y = -ProgressBar.PERFORM_DISTANCE_Y;
        a[x].lUp = true;
      }

      pointContainer.setInteractive({ hitArea: new Phaser.Geom.Rectangle(-ProgressBar.PERFORM_RADIUS * 2, -ProgressBar.PERFORM_RADIUS * 2, ProgressBar.PERFORM_RADIUS * 4, ProgressBar.PERFORM_RADIUS * 4), hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: true });
      pointContainer.on("pointerover", this.onOverPoint.bind(this, a[x], point, pointContainer));
      pointContainer.on("pointerout", this.onOutPoint.bind(this, a[x], point, pointContainer));
      pointContainer.on("pointerup", this.onJumpAlt.bind(this, pointContainer.x));
      this.points.push({ container: pointContainer, data: a[x], point });
    }
  }

  /*clickedPoint(data, x, e) {
    console.log(e);
    this.onJumpBar(e, x);
  }*/

  onOverPoint(data, point, pointContainer) {
    this.removePanel();
    this.videoAlreadyPaused = false;
    if (MainScene.that.videoPaused) {
      this.videoAlreadyPaused = true;
    }

    let endLine = ProgressBar.LINE_WIDTH;
    if (!data.lUp) {
      endLine += ProgressBar.PERFORM_DISTANCE_Y * 2;
    }
    // Contenitore
    const panelContainer = this.scene.add.container(0, 0);
    this.add(panelContainer);
    panelContainer.x = pointContainer.x;
    panelContainer.y = pointContainer.y;

    // Testo
    const txt = this.scene.add.text(0, 0, data.title.toUpperCase(), { fontFamily: "DIN Next LT Pro", fontSize: "36px", color: this.toHexColor(ProgressBar["COLOR_TEXT_" + data.type]), align: "center", wordWrap: { width: 320 }, lineSpacing: -6 });
    txt.setOrigin(0, 0);
    panelContainer.add(txt);
    txt.x = -Math.floor(txt.width / 2);
    txt.y = -endLine - txt.height - ProgressBar.PADDING_PANEL;

    // Immagine
    const img = this.scene.add.image(0, 0, "info_" + data.type);
    img.setOrigin(0, 0);
    panelContainer.add(img);
    txt.x -= img.width;
    img.x = txt.x + txt.width + img.width / 2;
    img.y = txt.y;

    img.setInteractive({ useHandCursor: true });
    img.on("pointerover", this.onOverImg.bind(this, img));
    img.on("pointerout", this.onOutImg.bind(this, img));
    img.on("pointerdown", this.onClick.bind(this, data));

    // Panel
    const panel = this.scene.add.rectangle(0, 0, txt.width + ProgressBar.PADDING_PANEL * 6 + img.width * 1.5, txt.height + ProgressBar.PADDING_PANEL * 2, ProgressBar["COLOR_" + data.type]);
    panelContainer.add(panel);
    panel.x = txt.x - ProgressBar.PADDING_PANEL * 3 + panel.width / 2;
    panel.y = txt.y - ProgressBar.PADDING_PANEL + panel.height / 2;
    img.y = panel.y + Math.floor(-img.height / 2);

    // Lineetta
    const vline = this.scene.add.rectangle(0, 0, 2, -endLine - panel.height / 2, ProgressBar["COLOR_" + data.type]);
    vline.setOrigin(0, 0);
    panelContainer.add(vline);
    vline.x -= 1;

    panelContainer.bringToTop(txt);
    panelContainer.bringToTop(img);
    this.bringToTop(panelContainer);

    let x0 = 0;
    let y0 = 0;
    const w = panel.width;
    const h = panel.height + endLine - 64;
    x0 = -w / 2;
    y0 = -h - 64;

    panelContainer.setInteractive({ hitArea: new Phaser.Geom.Rectangle(x0, y0, w, h), hitAreaCallback: Phaser.Geom.Rectangle.Contains, useHandCursor: false });
    panelContainer.on("pointerover", this.onOverPanel.bind(this));
    panelContainer.on("pointerout", this.onOutPanel.bind(this));

    /*const test = this.scene.add.rectangle(x0, y0, w, h, 0);
    test.setOrigin(0, 0);
    panelContainer.add(test);*/

    this.panelInfo = { panelContainer, vline, txt, img, panel };
    this.animatePanelInfo();
  }

  onClick(data) {
    MainScene.that.showDisabler(true);

    /*    if (!MainScene.that.videoPaused) {
      MainScene.that.togglePlayPause();
    }*/
    this.removePanel();
    MainScene.that.openLayer(data);
  }

  onOverImg(img) {
    img.alpha = 0.75;
    clearTimeout(this.idp);
    clearTimeout(this.ttp);
  }

  onOutImg(img) {
    img.alpha = 1;
  }

  onOverPanel() {
    clearTimeout(this.idp);
  }

  onOutPanel() {
    this.idp = setTimeout(this.removePanel.bind(this), 10);
    this.ttp = setTimeout(this.checkIfPlay.bind(this), 10);
  }

  checkIfPlay() {
    //console.log("ZIO CANE");
    //this.onOut();
  }

  animatePanelInfo() {
    const { panelContainer, vline, txt, img, panel } = this.panelInfo;

    vline.setScale(1, 0.01);
    txt.visible = false;
    img.visible = false;
    panel.visible = false;

    this.scene.tweens.add({
      targets: vline,
      scaleY: 1,
      duration: ProgressBar.TWEEN_TIME,
      ease: Phaser.Math.Easing.Quartic.Out,
      onComplete: this.showPanel.bind(this),
    });
  }

  showPanel() {
    if (this.panelInfo) {
      const { panelContainer, vline, txt, img, panel } = this.panelInfo;
      panel.visible = true;
      panel.setScale(0.01, 0.01);

      this.scene.tweens.add({
        targets: panel,
        scaleX: 1,
        scaleY: 1,
        duration: ProgressBar.TWEEN_TIME,
        ease: Phaser.Math.Easing.Quartic.Out,
        onComplete: this.showPanelContent.bind(this),
      });
    }
  }

  showPanelContent() {
    if (this.panelInfo) {
      const { panelContainer, vline, txt, img, panel } = this.panelInfo;
      txt.visible = true;
      img.visible = true;
    }
  }

  onOutPoint(data, point, pointContainer) {
    clearTimeout(this.idp);
    this.idp = setTimeout(this.removePanel.bind(this), ProgressBar.TIME_ROLLOUT);
  }

  removePanel() {
    clearTimeout(this.idp);
    const { panelInfo } = this;
    if (panelInfo) {
      for (const name in panelInfo) {
        const el = this.panelInfo[name];
        const tweens = this.scene.tweens.getTweensOf(el);
        for (let x = 0; x < tweens.length; x++) {
          tweens[x].remove();
        }
        el.destroy();
      }
      this.panelInfo = null;
      if (!this.videoAlreadyPaused) {
        this.onOut();
      }
    }
  }

  toHexColor(num) {
    let s = num.toString(16);
    while (s.length < 6) {
      s = "0" + s;
    }
    return "#" + s;
  }

  hidePoints() {
    const a = this.points;
    for (let x = 0; x < a.length; x++) {
      const point = a[x];
      this.scene.tweens.add({
        targets: point.container,
        scaleX: 0.001,
        scaleY: 0.001,
        alpha: 0,
        duration: ProgressBar.TWEEN_TIME,
        ease: Phaser.Math.Easing.Quartic.Out,
      });
    }
  }

  showPoints() {
    const a = this.points;
    for (let x = 0; x < a.length; x++) {
      const point = a[x];
      this.scene.tweens.add({
        targets: point.container,
        scaleX: 1,
        scaleY: 1,
        alpha: 1,
        duration: ProgressBar.TWEEN_TIME,
        ease: Phaser.Math.Easing.Quartic.Out,
      });
    }
  }

  gotoForcedPosition(posTestina) {
    //console.log("gotoForcedPosition", posTestina);
    this.onJumpBar(null, posTestina);
    this.smaller.visible = true;
    this.bigger.visible = false;
    this.videoAlreadyPaused = true;
  }

  onShowZoomPanel(uid, stroke, posxStroke, posTestina, strokeNumber) {
    //console.log(this.lastUidZoomPanel, uid);
    if (this.lastUidZoomPanel !== uid) {
      this.gotoForcedPosition(posTestina);
      // Salta all'inizio del colpo
      this.lastUidZoomPanel = uid;
      this.zoomPanel = new ZoomPanel(this.scene, stroke, this, strokeNumber, this.handleZoomPanelEvents.bind(this));
      this.zoomPanel.init();
      this.add(this.zoomPanel);
      this.zoomPanel.x = posxStroke - this.zoomPanel.width / 2;
      this.zoomPanel.y = -UiInterface.BAR_Y - this.zoomPanel.height - 4;

      const delta = (Tracking.WIDTH - UiInterface.PROGRESS_BAR_WIDTH) / 2 + 16;
      // Controlla che zoomPanel non esca dallo schermo
      if (this.zoomPanel.x < -delta) {
        this.zoomPanel.x = -delta;
      }

      if (this.zoomPanel.x + this.zoomPanel.width + delta > Tracking.WIDTH) {
        //console.log(this.zoomPanel.x + this.zoomPanel.width + delta);
        this.zoomPanel.x = Tracking.WIDTH - this.zoomPanel.width - delta;
      }

      // In realtà poi lo forzo al centro
      this.zoomPanel.x = (this.barWidth - this.zoomPanel.width) / 2;

      // O forse tutto a destra, devo ancora decidere
      this.zoomPanel.x = this.barWidth - this.zoomPanel.width + delta - 32;
    } else {
      this.closeZoomPanel();
    }
  }

  handleZoomPanelEvents(e) {
    this.dispatch(e.type, e.data);
  }

  closeZoomPanel() {
    if (this.zoomPanel) {
      this.zoomPanel.dispose();
      this.zoomPanel = null;
      this.lastUidZoomPanel = null;
    }
  }

  prevFrame() {
    // Lo manda al frame precedente
    // Prende il time corrente
    const time = MainScene.that.vid.getCurrentTime();
    const duration = MainScene.that.vid.getDuration();
    const perc = time / duration;
    // Calcola il nuovo frame
    let newFrame = perc * duration * MainScene.FPS;
    newFrame--;
    // Ricalcola il tempo del nuovo frame
    const newTime = newFrame / MainScene.FPS;
    // Lo manda al nuovo frame
    if (this.zoomPanel) {
      /*if (newFrame < this.zoomPanel.startFrame) {
        const time = this.zoomPanel.startFrame / MainScene.FPS;
        this.gotoTime(time);
      } else {
        if (newTime < time) {
          this.gotoTime(newTime);
        }
      }*/
      if (newFrame < this.zoomPanel.startFrame) {
        //const time = this.zoomPanel.startFrame / MainScene.FPS;
        //this.gotoTime(time);
        this.closeZoomPanel();
      } else {
        if (newTime < time) {
          this.gotoTime(newTime);
        }
      }
    } else {
      if (newTime < time) {
        this.gotoTime(newTime);
      }
    }
  }

  nextFrame() {
    // Lo manda al prossimo frame
    // Prende il time corrente
    const time = MainScene.that.vid.getCurrentTime();
    const duration = MainScene.that.vid.getDuration();
    const perc = time / duration;
    // Calcola il nuovo frame
    let newFrame = perc * duration * MainScene.FPS;
    newFrame++;
    // Ricalcola il tempo del nuovo frame
    const newTime = newFrame / MainScene.FPS;

    //console.log(time, newTime);

    // Lo manda al nuovo frame
    if (this.zoomPanel) {
      /*if (newFrame > this.zoomPanel.endFrame) {
        const time = this.zoomPanel.startFrame / MainScene.FPS;
        this.gotoTime(time);
      } else {
        if (newTime > time) {
          this.gotoTime(newTime);
        }
      }*/
      if (newFrame > this.zoomPanel.endFrame) {
        this.closeZoomPanel();
        //const time = this.zoomPanel.startFrame / MainScene.FPS;
        //this.gotoTime(time);
      } else {
        if (newTime > time) {
          this.gotoTime(newTime);
        }
      }
    } else {
      if (newTime > time) {
        this.gotoTime(newTime);
      }
    }
  }
}

ProgressBar.COLOR_BACK = 0xffffff;
ProgressBar.COLOR_FRONT = 0x152ba0;
ProgressBar.COLOR_LABELS = 0x00daff;
ProgressBar.CIRCLE_RADIUS = 10;
ProgressBar.CIRCLE_RADIUS_BIGGER = 15;

ProgressBar.EVENT_PAUSE = "eventPause";
ProgressBar.EVENT_RESUME = "eventResume";
ProgressBar.EVENT_MOVED_KNOB = "eventMovedKnob";
ProgressBar.EVENT_SHOW_TIME_TO_SEEK_TO = "eventShowTimeToSeekTo";
ProgressBar.EVENT_HIDE_TIME_TO_SEEK_TO = "eventHideTimeToSeekTo";

ProgressBar.VBAR_HEIGHT = 10;
ProgressBar.VBAR_HEIGHT_START_STROKE = 40;

ProgressBar.COLOR_0 = 0xff0000;
ProgressBar.COLOR_1 = 0xffffff;
ProgressBar.COLOR_2 = 0x00daff;

ProgressBar.COLOR_TEXT_0 = 0xffffff;
ProgressBar.COLOR_TEXT_1 = 0xff0000;
ProgressBar.COLOR_TEXT_2 = 0x162ca1;

ProgressBar.PERFORM_RADIUS = 6;
ProgressBar.PERFORM_RADIUS = 6;
ProgressBar.PERFORM_DISTANCE_Y = 28;

ProgressBar.PERFORM_KO = 0;
ProgressBar.PERFORM_WA = 1;
ProgressBar.PERFORM_OK = 2;
ProgressBar.LINE_WIDTH = 80;
ProgressBar.PADDING_PANEL = 10;

ProgressBar.TWEEN_TIME = 250;
ProgressBar.TIME_ROLLOUT = 200;

ProgressBar.ERROR_COLOR_INTERVAL = 1;
ProgressBar.NO_ERROR_COLOR = 0x00ff00;
ProgressBar.NO_DATA_COLOR = 0x999999;
/*ProgressBar.ERROR_COLORS = [
  0xb3b000, // giallo ancora più brillante
  0xcccc00, // giallo brillante
  0xe6e600, // giallo molto brillante
  0xffff00, // giallo acceso
  0x800000, // rosso scuro/spento
  0x990000, // rosso leggermente più brillante
  0xb30000, // rosso ancora più brillante
  0xcc0000, // rosso brillante
  0xe60000, // rosso molto brillante
  0xff0000, // rosso acceso
];*/

/*ProgressBar.ERROR_COLORS = [
  0xffff99, // Giallo Crema
  0xffff00, // Giallo
  0xffdf00, // Giallo Dorato
  0xff7f00, // Arancione
  0xff5f00, // Arancione Rosso
  0xff3f00, // Rosso Arancio
  0xff0000, // Rosso Vivo
];*/
ProgressBar.ERROR_COLORS = [0xffff99, 0xffe47f, 0xffc966, 0xffaf4c, 0xff9433, 0xff7919, 0xff5f00];
